import { useMutation, useQuery } from "@tanstack/react-query";
import { useContext } from "react";

import { SimpleSnackbarContext } from "../components/SimpleSnackbar";
import { language } from "../language";
import { customFetch } from "../util/customFetch";

export function useMetadatas({ enabled = true, params }) {
  const page = params.page;
  const size = params.pageSize;
  const sortOrder = params.sortOrder || "desc";
  const sort = params.sortBy
    ? `${params.sortBy},${sortOrder}`
    : params.sort
      ? `${params.sort},${sortOrder}`
      : "";
  const queryParams = { page, size, sortOrder, sort };
  return useQuery({
    enabled,
    queryKey: ["metadatas", queryParams],
    queryFn: async () =>
      customFetch(
        `/api/smartform/{tenant}/metadatas?${new URLSearchParams(queryParams)}`,
      ),
  });
}

export function useMetadataCreate() {
  const { actions: snackActions } = useContext(SimpleSnackbarContext);
  return useMutation({
    mutationFn: async (payload) => {
      return await customFetch(`/api/smartform/{tenant}/metadatas`, {
        method: "POST",
        body: JSON.stringify(payload),
      });
    },
    onSuccess: () => {
      snackActions.open(language.draftUpdated, { severity: "success" });
    },
    onError: (error) => {
      snackActions.open(language.errorDraftSave, { severity: "error" });
    },
  });
}

export function useMetadataById({ enabled = true, param }) {
  return useQuery({
    enabled,
    queryKey: ["metadatas", param],
    queryFn: async () =>
      customFetch(`/api/smartform/{tenant}/metadatas/${param}`),
  });
}

export function useMetadataTypes({ enabled = true }) {
  return useQuery({
    enabled,
    queryKey: ["metadatas", "types"],
    queryFn: async () => customFetch(`/api/smartform/{tenant}/types`),
  });
}
